// Retry functionality for lazy loading components.
// Accepts import() function for dynamically importing components,
// and will recursively call itself until the import is successful. Default is max 5 attempts
const LazyLoadRetry = (lazyImportFn, attemptsLeft = 5) => {
  return new Promise((resolve, reject) => {
    // String variable used to indicate if the page has been refreshed or not
    const refresh = "page-has-been-force-refreshed";

    // Get the current state of the refresh variable
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem(refresh) || "false"
    );

    // Import the component using lazyImportFn()
    lazyImportFn()
      .then((component) => {
        // Component was loaded successfully...refresh not needed (set to false)
        window.sessionStorage.setItem(refresh, "false");
        resolve(component);
      })
      .catch((error) => {
        // Log the lazy loader error
        console.log("LazyLoader error: " + error);

        // Execute the if block if the page has not been refreshed yet
        if (!hasRefreshed) {
          // Component was not loaded successfully...refresh required (set to true)
          window.sessionStorage.setItem(refresh, "true");
          // Reload the page
          window.location.reload();
        }

        // Retry after 1000 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          LazyLoadRetry(lazyImportFn, attemptsLeft - 1).then(resolve, reject);
        }, 1000);
      });
  });
};

export default LazyLoadRetry;
